module.exports = __webpack_public_path__ + "img/email_icon.28a58c82.png";